import { getUnleashClientRouter } from '@inkitt/contracts-common';
import { c } from '../../contract';
import { adSkipsRouter } from './ad-skips.router';
import { adminRouter } from './adminRouter';
import { authorFollowersRouter } from './authorFollowers';
import { bookCoverProgressIndicatorsRouter } from './bookCoverProgressIndicators.router';
import { bookShopRouter } from './bookShop.router';
import { candyJarRouter } from './candyjar.router';
import { contentEngagementRouter } from './contentEngagement.router';
import { customerSupportRouter } from './customerSupport.router';
import { deepLinkingRouter } from './deepLinking.router';
import { dynamicPaywallRouter } from './dynamicPaywall.router';
import { emailVerificationRouter } from './email-verification.router';
import { familyPlanRouter } from './family-plan.router';
import { featureFlagsRouter } from './feature-flags.router';
import { iterableWrapperRouter } from './iterable-wrapper-router';
import { notificationsCenterRouter } from './notifications-center.router';
import { paywallRouter } from './paywall.router';
import { pointsRouter } from './points.router';
import { progressResetRouter } from './progressResetRouter';
import { promoCodeRouter } from './promo-code.router';
import { promoShelfRouter } from './promo-shelf.router';
import { promotionalOfferRouter } from './promotionalOffer.router';
import { referralCodeRouter } from './referralCode.router';
import { seriesRouter } from './series.router';
import { socialProofRouter } from './socialProof.router';
import { topOnePercentUsersRouter } from './topOnePercentUsersRouter.router';
import { translationsRouter } from './translations.router';
import { unleashRouter } from './unleash.router';
import { userRouter } from './user.router';
import { userProfileRouter } from './userProfile.router';
import { userStoriesCommentsRouter } from './userStoriesComments.router';
import { webRouter } from './web.router';
import { webhooksRouter } from './webhooks';
import { wrapUpRouter } from './wrap-up.router';

export const v1Router = c.router(
  {
    adSkips: adSkipsRouter,
    admin: adminRouter,
    authorFollowers: authorFollowersRouter,
    bookCoverProgressIndicators: bookCoverProgressIndicatorsRouter,
    bookShop: bookShopRouter,
    candyJar: candyJarRouter,
    contentEngagement: contentEngagementRouter,
    customerSupport: customerSupportRouter,
    deepLinking: deepLinkingRouter,
    dynamicPaywall: dynamicPaywallRouter,
    emailVerification: emailVerificationRouter,
    familyPlan: familyPlanRouter,
    iterableWrapper: iterableWrapperRouter,
    notificationsCenter: notificationsCenterRouter,
    points: pointsRouter,
    progressReset: progressResetRouter,
    promoCode: promoCodeRouter,
    promoShelf: promoShelfRouter,
    promotionalOffer: promotionalOfferRouter,
    referralCode: referralCodeRouter,
    series: seriesRouter,
    socialProof: socialProofRouter,
    topOnePercentUsers: topOnePercentUsersRouter,
    translations: translationsRouter,
    unleash: unleashRouter,
    user: userRouter,
    userProfile: userProfileRouter,
    userStoriesComments: userStoriesCommentsRouter,
    web: webRouter,
    webhooks: webhooksRouter,
    wrapUp: wrapUpRouter,
    paywall: paywallRouter,
    featureFlags: featureFlagsRouter,
    unleashClient: getUnleashClientRouter(c),
  },
  { pathPrefix: '/v1' },
);
